module.exports = __webpack_public_path__ + "static/media/dodgem(15).707e85a2.PNG";